import { useContext } from "react";
import { VersionContext } from "~/versionControl/context";
import { get } from "lodash";

/**
 * Инкапсуляция контекста
 * Если будет необходим доп функционал/обработка данных контекста
 * */
const useVersionContextSpecificSet = () => {
  const { state } = useContext(VersionContext);
  return get(state, "actualVersionControl", state.fallBackVersionControl)
    .specificSet;
};

export default useVersionContextSpecificSet;
